module.exports = __webpack_public_path__ + "img/share_icon.b2a41c38.svg";